import { render } from "./Pdf1.vue?vue&type=template&id=d2ec8896"
import script from "./Pdf1.vue?vue&type=script&lang=js"
export * from "./Pdf1.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__